/**
 * Hook useAuth
 * Facilita acesso às funções de autenticação
 * Este hook é um wrapper do AuthContext para facilitar o uso
 */

import { useAuth as useAuthContext } from "../contexts/AuthContext";

/**
 * Hook para usar autenticação
 * Retorna todas as funções e estados de autenticação
 */
export const useAuth = () => {
  return useAuthContext();
};

export default useAuth;
